import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ProfileContext } from '../../context/Profile.context';
import { Box, Checkbox, Typography } from '@otcmarketsgroup/otcm-ui-lib';

const VerifyBox = ({ section, 'data-testid': dataTestId }) => {
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const profileData = profileState.profile;
    const verifiedSections = profileData.verifiedSections;
    const enableSection = profileState.enableVerifiedSections;
    const disabled = !enableSection[section];

    const onContainerClick = () => {
        if (disabled) return;

        const updatedObj = { ...verifiedSections, [section]: !verifiedSections[section] };

        dispatchProfile({
            type: 'UPDATE_PROFILE',
            field: 'verifiedSections',
            payload: updatedObj
        });
    };

    return <Box data-testid={dataTestId} sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: 'center',
        backgroundColor: 'var(--otc-green)',
        opacity: disabled ? 0.75 : 1,
        borderRadius: 1,
        height: "100%",
        minHeight: 40,
        cursor: disabled ? 'not-allowed' : 'pointer',
        ":hover": {
            backgroundColor: disabled ? 'var(--otc-green)' : 'rgb(0, 117, 100)'
        }
    }} onClick={onContainerClick}>
        <Checkbox
            color="secondary"
            data-testid={dataTestId ? `${dataTestId}-checkbox` : undefined}
            checked={verifiedSections[section]}
            disabled={disabled}
            readOnly />
        <Typography variant='subtitle1' component='span' color='var(--otc-white)'>
            I have verified all information on this page.
        </Typography>
    </Box>;
};

VerifyBox.propTypes = {
    section: PropTypes.string,
    'data-testid': PropTypes.string
};

export default VerifyBox;
